import React from "react";
import { withStyles } from "@material-ui/core/styles";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  DialogActions,
  Button,
  IconButton
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import Tooltip from "../../common/StyledToolTip";

const styles = theme => ({
  dialogContainer: {
    padding: 16,
    userSelect: "none",
    backgroundColor: theme.ModalBGColor,
    minWidth: 400,
    maxWidth: 662
  },
  dialogTitle: {
    fontSize: 16,
    fontWeight: 600,
    color: theme.HeaderSelectedText
  },
  dialogContent: {
    color: theme.gridTextColor,
    fontSize: 12,
    fontWeight: 600
  },
  closeIconStyle: {
    padding: "0px",
    float: "right",
    color: theme.HeaderDefaultTextColor,
    "&:hover": {
      backgroundColor: theme.ModalBGColor,
      color: theme.HeaderSelectedText
    }
  },
  closeIcon: {
    fontSize: 24
  },
  actionContainer: {
    width: "60%"
  },
  dialogActionStyle: {
    padding: "0px 24px"
  },
  dialogButtonStyle: {
    fontSize: 14,
    textTransform: "none",
    borderRadius: "2px",
    float: "right",
    width: "35%"
  },
  textOverflow: {
    maxWidth: 600,
  }
});

const DynamicRoutingFeedback = props => {
  const {
    classes,
    show,
    onClose,
    affectedRoutes,
    lastWaveRoutes,
    extraTrailerRoutes
  } = props;
  return (
    <Dialog
      open={show}
      onClose={onClose}
      classes={{ paper: classes.dialogContainer }}
      aria-labelledby="dynamic-routing-feedback"
    >
      <DialogTitle classes={{ root: classes.dialogTitle }} disableTypography>
        Dynamic Routing Completed Successfully
        <IconButton
          aria-label="Close"
          classes={{ root: classes.closeIconStyle }}
          onClick={onClose}
        >
          <CloseIcon classes={{ root: classes.closeIcon }} />
        </IconButton>
      </DialogTitle>
      <DialogContent classes={{ root: classes.dialogContent }}>
        {Boolean(affectedRoutes && affectedRoutes.length) && (
          <Tooltip title={affectedRoutes.join(", ")}>
            <p className={classes.textOverflow}>
              {`${affectedRoutes.length} Routes created: ${affectedRoutes &&
                affectedRoutes.length &&
                affectedRoutes.join(", ")}`}
            </p>
          </Tooltip>
        )}
        {Boolean(lastWaveRoutes && lastWaveRoutes.length) && (
          <Tooltip title={lastWaveRoutes.join(", ")}>
            <p className={classes.textOverflow}>
              {`Shipments arriving after last wave cutoff were routed to: ${lastWaveRoutes.join(
                ", "
              )}`}
            </p>
          </Tooltip>
        )}
        {Boolean(extraTrailerRoutes && extraTrailerRoutes.length) && (
          <Tooltip title={extraTrailerRoutes.join(", ")}>
            <p className={classes.textOverflow}>
              {`Extra routes created to route shipments with special equipment preference: ${extraTrailerRoutes.join(
                ", "
              )}`}
            </p>
          </Tooltip>
        )}
      </DialogContent>
      <DialogActions classes={{ root: classes.dialogActionStyle }}>
        <div className={classes.actionContainer}>
          <Button
            variant="contained"
            onClick={onClose}
            color="primary"
            size="medium"
            classes={{
              root: classes.dialogButtonStyle
            }}
          >
            Done
          </Button>
        </div>
      </DialogActions>
    </Dialog>
  );
};

export default withStyles(styles)(DynamicRoutingFeedback);
